/** @jsx jsx */
import { Flex, Heading } from "@eworkit/iris";
import { FC, ReactNode } from "react";
import { jsx } from "theme-ui";

interface IconedHeaderProps {
  icon: ReactNode;
  heading: ReactNode;
  status?: ReactNode;
}

export const IconedHeader: FC<IconedHeaderProps> = ({ icon, heading, status, children }) => {
  return (
    <Flex gap="sm">
      <Flex
        sx={{
          "& > [data-icon], [data-loader]": {
            fontSize: 40,
            color: "vg500",
          },
        }}>
        {icon}
      </Flex>

      <Flex flexDirection="column">
        <Flex flexDirection={["column", null, "row"]} gap={["xxs", null, "xs"]} alignItems={[null, null, "center"]}>
          <Heading size="h-sm" sx={{ fontWeight: 500 }}>
            {heading}
          </Heading>

          {status && <div>{status}</div>}
        </Flex>

        {children}
      </Flex>
    </Flex>
  );
};
